const initialState = {
    pagination: 1,
    pageSize: 10,
    status: null, //'firstLine',
    closed: null,
    sort: {
        prop: 'creationDate',
        order: 'desc'
    },
    searchString: '',
    start: 0,
    total: 0
}

export const incidents = {
    namespaced: true,
    state: initialState,
    actions: {},
    setters: {},
    mutations: {
        setStatus(state, value) {
            state.status = value;
        },
        setPageSize(state, value) {
            state.pageSize = value;
        },
        setPagination(state, value) {
            state.pagination = value;
        },
        setClosing(state, value) {
            state.closed = value;
        },
        setStart(state, value) {
            state.start = value;
        },
        setSearch(state, value) {
            state.searchString = value;
        },
        setSort(state, value) {
            state.sort = value;
        },
        setTotal(state, value) {
            state.total = value;
        },
    }
};
